import React, { useContext } from 'react'
import { DateFormatter } from '../utils/DateFormatter'
import Context from '../context/Context'

const InvoiceFinalInvoice = () => {
  const context = useContext(Context)

  return (
    <div className="row mt-3 mb-3">
      <div className="col-10 offset-1 text-center">
        <span className="paragraph-regular-18">Här är din </span><span className="paragraph-bold-18">slutfaktura</span><span className="paragraph-regular-18"> för perioden </span><br />
        <span className="paragraph-bold-18">{context.invoice.contract_start_date}</span> <span className="paragraph-regular-18">till</span> <span className="paragraph-bold-18">{DateFormatter.getFinalInvoicePeriodEndDate(context.invoice.contract_termination_date)}</span>
      </div>
    </div>
  )
}

export default InvoiceFinalInvoice
